import { PimentoPost, PimentoDelete } from "./apiUtils";

class ApiSurveys {
  public static getSurvey(surveyId: number, signal?: AbortSignal) {
    return fetch(`/api/v1/surveys/${surveyId}`, {
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      signal,
    }).then((response) => {
      if (!response.ok) {
        throw new Error(
          `Failed to fetch survey: ${response.status} ${response.statusText}`
        );
      }
      return response.json();
    });
  }

  public static updateSurvey(surveyId: number, fields: { [key: string]: any }) {
    const updateSurveyRoute = `/api/v1/surveys/${surveyId}`;
    const allowedFields = [
      "label",
      "location",
      "site_id",
      "nominal_flight_date",
      "timezone",
      "start_time",
      "end_time",
      "zoom_start",
      "log",
    ].reduce((allowed, key) => {
      if (key === "site_id" && fields[key] === null) {
        return { ...allowed, [key]: null };
      }

      if (fields[key]) {
        return { ...allowed, [key]: fields[key] };
      }
      return allowed;
    }, {});

    return fetch(updateSurveyRoute, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(allowedFields),
    });
  }

  public static lockSurvey(surveyId: number) {
    return PimentoPost(`/api/v1/surveys/${surveyId}/lock`, undefined, {
      error: "Failed to lock survey",
    });
  }

  public static unlockSurvey(surveyId: number) {
    return PimentoPost(`/api/v1/surveys/${surveyId}/unlock`, undefined, {
      error: "Failed to unlock survey",
    });
  }

  public static generateSurveyReport(surveyId: number) {
    return PimentoPost(`/api/v1/surveys/${surveyId}/report`, undefined, {
      error: "Survey locked, but report generation failed",
    });
  }

  public static archiveSurvey(surveyId: number) {
    return PimentoPost(`/api/v1/surveys/${surveyId}/archive`, undefined, {
      error: "Failed to archive survey",
    });
  }

  public static restoreSurvey(surveyId: number) {
    return PimentoPost(`/api/v1/surveys/${surveyId}/restore`, undefined, {
      error: "Failed to restore survey",
    });
  }

  public static assignTagToSurvey(surveyId: number, tagId: number, signal?: AbortSignal) {
    return PimentoPost(
      `/api/v1/surveys/${surveyId}/tags`,
      { tagId },
      { error: "Failed to assign tag" },
      signal
    );
  }

  public static removeTagFromSurvey(surveyId: number, tagId: number, signal?: AbortSignal) {
    return PimentoDelete(`/api/v1/surveys/${surveyId}/tags/${tagId}`, {
      error: "Failed to remove tag",
    }, signal);
  }

  public static removeTagsFromSurvey(surveyId: number, tagIds: number[]) {
    return PimentoDelete(`/api/v1/surveys/${surveyId}/tags`, {
      error: "Failed to remove tags",
      body: { tagIds },
    });
  }
}

export default ApiSurveys;
